module.exports = {
      id: "bondhushava-usage",
      viewBox: "0 0 225 61",
      url: "/" + "sprite-79b777a110ad18271a4fc79289e4208e.svg#bondhushava",
      toString: function () {
        return this.url;
      }
    }